import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { useState, useEffect } from 'preact/compat';
import ProjectTeasers from './ProjectTeasers';
import FinderStatus from './FinderStatus';
export default function ProjectFinder() {
    const [initializing, setInitializing] = useState(true);
    const [selectedTopic, setSelectedTopic] = useState(0);
    const [selectedState, setSelectedState] = useState(0);
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.has('topic')) {
            const topic = parseInt(params.get('topic'));
            if (Number.isInteger(topic)) {
                setSelectedTopic(topic);
            }
        }
        if (params.has('state')) {
            const state = parseInt(params.get('state'));
            if (Number.isInteger(state)) {
                setSelectedState(state);
            }
        }
        setInitializing(false);
    }, []);
    useEffect(() => {
        const url = new URL(window.location.href);
        url.searchParams.delete('topic');
        url.searchParams.delete('state');
        if (selectedTopic) {
            url.searchParams.set('topic', selectedTopic.toString());
        }
        if (selectedState) {
            url.searchParams.set('state', selectedState.toString());
        }
        window.history.replaceState({}, '', url.href);
    }, [selectedTopic, selectedState]);
    if (initializing) {
        return null;
    }
    const filteredProjects = getFilteredProjects(selectedTopic, selectedState);
    return (_jsxs(_Fragment, { children: [_jsxs("form", Object.assign({ name: "project-finder", class: "project-finder__form" }, { children: [_jsxs("div", Object.assign({ class: "project-finder__select-wrapper" }, { children: [_jsx("label", Object.assign({ htmlFor: "topic" }, { children: "Themenbereich" }), void 0), _jsx("select", Object.assign({ name: "topic", id: "topic", autocomplete: "off", value: selectedTopic, onChange: (e) => setSelectedTopic(parseInt(e.currentTarget.value)) }, { children: finderData.topics.map(({ id, label }) => (_jsx("option", Object.assign({ value: id }, { children: label }), void 0))) }), void 0)] }), void 0), _jsxs("div", Object.assign({ class: "select-wrapper" }, { children: [_jsx("label", Object.assign({ htmlFor: "topic" }, { children: "Bundesland" }), void 0), _jsx("select", Object.assign({ name: "state", id: "state", autocomplete: "off", value: selectedState, onChange: (e) => setSelectedState(parseInt(e.currentTarget.value)) }, { children: finderData.states.map(({ id, label }) => (_jsx("option", Object.assign({ value: id }, { children: label }), void 0))) }), void 0)] }), void 0)] }), void 0), _jsx(FinderStatus, { count: filteredProjects.length, mode: "project" }, void 0), _jsx(ProjectTeasers, { projects: filteredProjects }, void 0)] }, void 0));
}
function getFilteredProjects(selectedTopic, selectedState) {
    const noTopicFilter = selectedTopic === 0;
    const noStateFilter = selectedState === 0;
    return finderData.projects
        .filter(({ topics }) => noTopicFilter || topics.includes(selectedTopic))
        .filter(({ states }) => noStateFilter || states.includes(selectedState));
}
